export default __webpack_public_path__ + "static/media/banner.20024ff8.png";